export default __webpack_public_path__ + "static/media/quotes.64ba90f6.png";